import type { ApplicationContext } from './shared-types'

import createSolidDataLoader from '@app/application/solid/services/solid-data-loader'

// True when Solid is enabled and the current company has at least one
// reconciliation template with a Solid build, decided server-side.
const isPreloadEnabled = (): boolean =>
  document.querySelector<HTMLInputElement>('#solid_preload_enabled')?.value ===
  'true'

export default (appContext: ApplicationContext): ApplicationContext => {
  window.silverfinSolidData ??= createSolidDataLoader()

  appContext.onDomLoad(() => {
    if (!isPreloadEnabled()) return

    const firmId = window.Silverfin?.currentFirmId
    const companyId = window.Silverfin?.currentCompanyId
    if (!firmId || !companyId) return

    const ledgerId = window.Silverfin.currentLedgerId() || undefined
    void window.silverfinSolidData?.loadData(firmId, companyId, ledgerId)
  })

  return appContext
}
